import { AppTableColumn } from '../_models/models';

const STRUCTURAL_COLUMN_TYPES = ['selections', 'expand-row', 'actions'];

/** A column the user may show/hide and resize: anything but the structural selection, expand and actions columns. */
export function isCustomizableColumn(column: AppTableColumn): boolean {
  return !!column && !STRUCTURAL_COLUMN_TYPES.includes(column.type);
}
